
<div class="formcontainer">


<div class="row mb-6">
    <div class="col justify-content-between">
      <img src="../../assets/webtree.png" class="img-fluid" alt="Webbtree" title="Webbtree">
      <span class="float-right"><button data-testid="auto-app-feedback-button-1" class="wc-btn btnreset" routerLink="/login">Sign In</button>
      </span>
    </div>
  </div>

  <div class="wccard py-3">
      <div class=" questioncontainer">
        <p class="f-24 font-weight-500 mb-6"> One Question before you Left</p>
        <p class="f-14"> Why are you uninstalling webbtree? </p>

        <div *ngFor = "let x of feedbackreason;let i = index">
            <div class="d-flex align-items-center mb-3">
                <label class="wc-checkbox mr-3 mb-0" >
                  <input data-testid="auto-app-feedback-input-1" type="checkbox" id="mycheck" name="mycheck" [(ngModel)]="x.selected" [checked]="selected === i" 
                  (click)="selectedreason(x);selected = i">
                  <i class="fas fa-check"></i>
                </label>
                <label class="mb-0">
                  <span class="f-14">{{x}}</span>
                </label>
              </div>
        </div>
   
            <textarea data-testid="auto-app-feedback-textarea-1" type="text" placeholder="Type your Answer here" class="wc-form-control nobg mb-3 col-md-5 h-105" [(ngModel)]="answer" *ngIf="selectedres == 'Other'"> </textarea>
      <p [ngClass]="['text-left','f-14','text-danger']"> {{ReasonRequired}} </p>
      </div>
      <button data-testid="auto-app-feedback-button-2" type="button" class="btn wc-btn-lg f-14 font-weight-500 bgRequestBtn mr-4 ml-6"
      data-dismiss="modal" (click)="submitreason()">Submit</button>

      </div></div>


      <ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
        <span class="successCheck"><i class="fal fa-check"></i> </span>
       <span class="successmsg">{{ successMessage }}</span>
      </ngb-alert>
      
      <ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
       <span class="errorCheck"><i class="fal fa-times"></i></span>
       <span class="errormsg"> {{ errorMessage }} </span>
      </ngb-alert>
      